export const yesOrNo = (value: boolean | null | undefined) => {
  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
  switch (value) {
    case true:
      return 'Yes';
    case false:
      return 'No';
    case null:
      return 'Unknown';
    default:
      return '-';
  }
};
